import {createElement} from 'react';

export function Display({what, ...props}) {
  if (what) {
    return createElement(what, props);
  }
  return props.children;
}
